<template lang="pug">
  div
    .modal-backdrop.fade.show
    .modal.fade.show
      .modal-dialog
        .modal-content
          .modal-body
            .text-center チェックイン
              button.close(@click="$emit('closeDialog')") ×　
            .my-4 
            .text-center
              b-spinner.mt-5.mb-5(variant="primary" label="Loading..." v-if="isLoading")
            //- チェックイン可能な岩場が複数存在する場合のリスト表示
            div#rockyList(v-if="isRockyListShow")
              .title.float-left.mt-2.mb-4.pl-1.col <b>チェックインできる岩場が複数あります。</b><br>リストから選択してください。
              .justify-content-center.col
                div(v-for="item in rockyList")
                  .card.mt-2(@click.prevent="dispCheckinView(item.rockyId)")
                    a.card-body.p-1
                      div
                        img.rocky-img.float-left.mr-1(:src="getRockyImgThumbPath(item.imgPath)")
                      div.img-back
                      div {{item.rockyName}}
                      .small.text-black-50 {{item.address}}
            //- チェックインできる岩場が2件以上の場合のみ表示
            .mb-3(v-if="this.rockyList.length > 1 && !isRockyListShow")
              a.return-link(@click="() => {isRockyListShow=true} ") < 岩場選択に戻る
            .my-5.text-center(v-if="message")
              i.fas.fa-exclamation-circle.text-warning.mr-2
              | {{ message }}
            div(v-if="isRocky && !isRockyListShow")
              div(v-if="!isRockyTodayCheckined")
                .title.float-left.mb-2.pl-2.col <b>岩場</b>
                .small.mb-3.ml-2 まだ岩に到着していない場合はここからチェックイン！
                .justify-content-center.col
                  div(v-for="item in rocky")
                    .card.mb-3
                      a.card-body.p-1(@click.prevent="checkin()")
                        div
                          img.rocky-img.float-left.mr-1(:src="getRockyImgThumbPath(item.imgPath)")
                        div.img-back
                        div {{item.rockyName}} 
                        .small.text-black-50 {{item.address}}
              .float-left.title.mb-2.pl-2.col <b>{{isRockyTodayCheckined? rocky[0].rockyName :'岩'}}</b>
              .small.mb-3.ml-2 岩に到着したらここからチェックイン！
              .alert.alert-danger(v-if="banFlgMessage") {{ banFlgMessage }}
              .row.mx-1
                .col-6.p-2(v-for="item in rockList" @click.prevent="checkin(item.id,item.banFlg,item.name)")
                  .rock-img-list-box.position-relative.d-flex.justify-content-center.bg-dark
                    img.position-absolute.mw-100.h-100(:src="createImgPath(item.imgList[0].path)")
                    .rocky-ban.position-absolute.text-danger.p-1.font-weight-bold(v-if="item.banFlg") 登攀禁止
                    .rock-name.h-auto.p-1.position-absolute.small.text-white.w-100 {{item.name}}
                    .rock-stamp(v-if="item.isCheckin")
                      img.mr-1(src="/img/checkin-stamp.svg")
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  //データオブジェクト
  data() {
    return {
      showModal: false,
      rocky: null,
      rockyList:[],
      rockList: null,
      materialURL: process.env.VUE_APP_MATERIAL_URL,
      message: '',
      rockyId: '',
      isRocky: false,
      rockId: null,
      lat: '',
      lng:'',
      isLoading: true,
      rockyImgPath: null,
      banFlgMessage: '',
      isBanFlg: '',
      checkinRockName: '',
      iconPath: '',
      isRockyListShow: false,
      userCheckinData: [],
      today: '',
      isRockyTodayCheckined:false
    }
  },
  //メソッド
  methods: {
    //座標取得処理
    getPosition: () => new Promise((resolve, reject) => {
      if (!navigator || !navigator.geolocation) reject()
      navigator.geolocation.getCurrentPosition(
        pos => resolve(pos),
        err => reject(err),
        {
          enableHighAccuracy: true,
          maximumAge: 300000,  // 5分前まで
          timeout: 5000
        }
      )
    }),

    async search() {
      //座標取得
      let pos
      try {
        pos = await this.getPosition()
        this.message = ''
        if (process.env.NODE_ENV === 'development') { // 開発時用座標
          this.lat = process.env.VUE_APP_DEV_CHECKIN_LAT
          this.lng = process.env.VUE_APP_DEV_CHECKIN_LNG
          // this.lat = 36.469661
          // this.lng = 138.106474
        } else {
          this.lat = pos.coords.latitude
          this.lng = pos.coords.longitude
        }

      } catch (err) {
        console.log(err)
        this.isLoading = false
        this.message = '現在地を取得できませんでした。端末、もしくはブラウザの位置情報の許諾に関する設定をご確認ください。'
        return
      }

      //岩場のデータ取得
      axios.get(process.env.VUE_APP_API_GATEWAY + '/api-rocky', {
        params: {
          "lat": this.lat,
          "lng": this.lng,
        },
        headers: {
          'Authorization': this.$user.idToken
        }
      })
      .then(res => {

        this.rockyList = res.data

        //チェックイン可能な岩場が複数ある場合は、選択画面を表示する
        if(this.rockyList.length > 1){
          this.isRockyListShow = true
          this.isLoading = false
          return
        }

        //チェックイン可能な岩場が1件の場合
        this.dispCheckinView(this.rockyList[0].rockyId)

      })
      .catch(err => {
        console.log(err)
        this.message = '近くの岩場がみつかりませんでした。'
        this.isLoading = false
      })
    },
    //チェックイン画面を表示する
    dispCheckinView(rockyId){
      
      this.isLoading = true

      this.rockyId = rockyId
      this.rocky = this.rockyList.filter(record => record.rockyId == rockyId)
      this.rockyName = this.rocky[0].rockyName

      //岩場IDに紐づく岩取得
      this.getRockList()
      this.isRockyListShow = false
      this.isLoading = false

    },
    //岩場IDに紐付く岩Listを取得    
    async getRockList(){

      this.isLoading = true

      const jsonUrl = process.env.VUE_APP_API_GATEWAY + '/api-rock'
      await axios.get(jsonUrl, {
        params: {
          "rockyId": this.rockyId,
          "isLogin": this.$user.isLogin
        },
        headers: {
          'Authorization': this.$user.idToken
        }
      })
      .then(res => {
        this.rockList = res.data.rockList
        this.isLoading = false
        this.isRocky = true
        //チェックイン済みの表示を行う。
        this.checkinDataExtractAndShow()
      })
    },
    getRockyImgThumbPath(imgPath){
      return this.getRockyThumbPath(imgPath,'120')
    },
    createImgPath(path){
      return this.getRockThumbPath(path,this.rockyId,'120')
    },
    //クリック時、チェックイン処理
    async checkin(id,banFlg,rockName) {

      this.rockId = id

      this.banFlgMessage = ''

      //登攀禁止の岩だった場合
      if(banFlg == true) {
        this.banFlgMessage = '登攀禁止の岩なので、チェックインできません。'
        return
      }

      //岩場選択時
      if(this.rockId == null) {
        this.rockId = 0
      }

      const url = process.env.VUE_APP_API_GATEWAY + '/api-checkin'
      const params = {
        rockyId: this.rockyId,
        rockId: this.rockId,
        lat: this.lat,
        lng: this.lng,
      }
      axios.post(url,params, {
        headers: {
          'Authorization': this.$user.idToken
        }
      })
      .then(res => {
        if(res.data.isLevelUp == false) {
          this.$emit('checkin', rockName ? rockName : this.rockyName)
          this.$emit('closeDialog')
        }else if(res.data.isLevelUp == true) {
          this.checkinRockName = rockName
          this.iconPath = res.data.iconPath
          this.$emit('levelUp', rockName ? rockName : this.rockyName, this.iconPath)
        }

        //ローカルストレージにチェックイン中フラグを立てる
        localStorage.lastCheckinDate = this.today

      })
      .catch(err => {
        console.log(err)
      })
    },
    //当日のユーザーチェックインデータを画面反映する
    async checkinDataExtractAndShow(){

      //対象の岩場IDの当日のチェックインデータを抽出する
      let wkList = this.userCheckinData.filter(record => record.rockyId == this.rockyId && !record.created.indexOf(this.today))

      //対象の岩場に対して当日の岩場チェックイン、岩チェックインが1件でもあればフラグをセット
      if(wkList.length > 0 ){
        this.isRockyTodayCheckined = true
      }

      let rockWkList = []
      this.rockList.forEach((record) => {
        //当日の岩チェックインの有無を取得する
        let isRockCheckined = wkList.filter(rock => rock.rockId == record.id).length > 0 ? true :false

        let rockName =  record.name == '' || record.name == null ? '（岩名無し）' : record.name

        rockWkList.push({
          id: record.id,
          isCheckin: isRockCheckined,
          banFlg: record.banFlg,
          name:rockName,
          imgList: record.imgList
        })
      })      

      this.rockList = rockWkList
    },
    //ユーザーのチェックイン記録を取得する
    async getCheckinData() {
      //チェックイン履歴の取得
      await axios.get(process.env.VUE_APP_API_GATEWAY + '/api-checkin', {
        params: {
          "targetUserId": this.$user.userId,
          "userId":this.$user.userId
        },
        headers: {
          'Authorization': this.$user.isLogin ? this.$user.idToken : 'no-login'
        }
      })
      .then(async res => {
        if(res.data.length > 0){
          this.userCheckinData = res.data
        }
        this.isLoading = false
      })
      .catch(err => {
        this.isLoading = false
        this.message = '情報の取得に失敗しました'
        return
      })
    },
  },
  //インスタンス作成後
  created() {
    document.body.classList.add('modal-open')

    this.today = this.getToday()

    this.getCheckinData()
    this.search()

  },
   // インスタンス破棄前
  beforeDestroy() {
    document.body.classList.remove('modal-open')
  },
  // コンポーネント
  components: {
  }
})
</script>

<style lang="stylus" scoped>
.modal
  display block
.return-link
  cursor pointer
.title
  border-left: 6px solid #027EC3
.card
  :hover
    cursor pointer
.rock-img-list-box
  padding-top 75%
  :hover
    box-shadow 0 3px 3px 0 rgba(0,0,0,0.14), 0 1px 7px 0 rgba(0,0,0,0.12), 0 3px 1px -1px rgba(0,0,0,0.2)
    cursor pointer
  :active
    opacity .8
  img
    top 0
  .rock-name
    bottom 0
    left 0
    background rgba(0, 0, 0, 0.5)
  .rocky-ban
    top 0
    left 0
    background rgba(222,225,227,0.6)
  .rock-stamp
    width 100%
    height 100%
    top 0
    background rgba(0,0,0,0.6)
    position absolute
    display flex
    justify-content center
    align-items center
    font-size 0.8rem
    cursor default
    img
      position absolute
      top 12%
      width 50%
      height auto
      pointer-events none

.rocky-img
  max-width 120px
  height auto
#rockyList
  background #dee1e3
  padding 1rem

/* IE11対策 */
.justify-content-center
   -ms-flex-pack start !important
</style>